import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function paidType() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`paid-type/search?${params}`);
    }

    function get(id) {
        return axiosInstance.get(`paid-type/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('paid-type/create', data);
    }

    function update(data) {
        return axiosInstance.patch(`paid-type/update`, data);
    }

    function remove(id) {
        return axiosInstance.delete(`paid-type/delete`, {
            data: {
                id: id
            }
        });
    }
}
